import { SBModel } from '@supplement-bacon/react-toolkit/models'
import { Localizable } from './Localizable'

interface NotificationContent
  extends SBModel, Localizable<NotificationContentLocalizable> {
  key: string
}

interface NotificationContentLocalizable {
  title: string
  content: string
  buttonLabel?: string
}

enum NotificationContentKey {
  NO_SHOW = 'noshow',
  FEEDBACK = 'feedback',

  /** MEMBERSHIP **/
  MEMBERSHIP_NOSHOW = 'membership_noshow',
  MEMBERSHIP_CONFIRMATION = 'membership_confirmation',
  MEMBERSHIP_BIRTHDAY_NOTIFICATION = 'membership_birthday_notification',
  MEMBERSHIP_BIRTHDAY_MODAL = 'membership_birthday_modal',

  /** GDPR **/
  GDPR_ACCOUNT_RETENTION_WARNING = 'gdpr_account_retention_warning',

  /** SMART BANNER **/

  SMART_BANNER = 'smart_banner',

  /** RESERVATION **/

  RESERVATION_PLACED = 'reservation_placed',
  RESERVATION_CONFIRMATION = 'reservation_confirmation',
  RESERVATION_UPDATED = 'reservation_updated',
  RESERVATION_CANCELLED = 'reservation_cancelled',
  RESERVATION_PAYLINK_NOTE_TO_GUEST = 'reservation_paylink_note_to_guest',

  /** BUSINESS **/

  /**
   * Used when a company is created, it's the initial email sent to the company contact
   */
  BUSINESS_COMPANY_CONTACT_CONFIRMATION_ADD = 'business_company_contact_confirmation_add',
  /**
   * Used when the code is generated for the company contact to link their business profile
   */
  BUSINESS_PROFILE_LINKING_CODE = 'business_profile_linking_code',
  /**
   * Used when a company contact is added by an other company contact from the company back-office
   */
  BUSINESS_COMPANY_CONTACT_ADDED = 'business_company_contact_added',

  // Register
  REGISTER_REQUIRED_OPT_IN_DATA = 'register_required_opt_in_data',
  REGISTER_OPTIONAL_OPT_IN_MARKETING = 'register_optional_opt_in_marketing',
  REGISTER_EXTRA_TEXT = 'register_extra_text',
}

export { NotificationContentKey }
export type { NotificationContent, NotificationContentLocalizable }
